import { Trans } from 'react-i18next'

import { ConditionFeatureFlag, ConditionTextOperator } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { appIconKeys } from '@/shared/icons/constants'

import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionSessionIdDD() {
  const { id, setOpen, isRhs, index } = useConditionSelectContext()
  const { onChange, value } = useConditionRepeaterContext()
  const key = isRhs ? 'rhs' : 'lhs'

  return (
    <div
      id={id ? `${id}-session-id` : undefined}
      onClick={() => {
        const nextCond = [...value.conditions]
        nextCond[index] = {
          ...nextCond[index],
          [key]: { flag: ConditionFeatureFlag.SessionId },
        }
        if (!isRhs) {
          nextCond[index].operator = ConditionTextOperator.IsNotEmpty
        }
        onChange?.({ isAny: value.isAny, conditions: nextCond })
        setOpen(false)
      }}
      className='flex-c w-full sdd-item'
    >
      <div className='flex-c w-full pointer-events-none'>
        <MaterialIcon icon={appIconKeys.tableSession} size={16} />
        <div className='pointer-events-none'>
          <Trans>Session ID</Trans>
        </div>
      </div>
    </div>
  )
}

export function ConditionSessionIdStatement({ statement }: { statement: any }) {
  return (
    <div className='flex items-center gap-1 min-w-0'>
      <MaterialIcon icon={appIconKeys.tableSession} size={14} />
      Session ID
    </div>
  )
}
